<template>
  <div class="how-it-works-section">
    <ol class="global-ol how-it-works-section__list">
      <li>Pick a creator to work with.</li>
      <li>Message the creator to hash out deliverables, compensation, and timing.</li>
      <li>Finalize the work agreement to formalize the collaboration.</li>
      <li>The creator completes the agreed upon work.</li>
      <li>Receive the deliverables, review the work, and transfer compensation.</li>
    </ol>

    <NoteWithIcon class="how-it-works-section__info-snippet">
      <template #icon><IconEmbedded name="info-simple_4" :size="28" /></template>
      <template #text>
        <div style="text-wrap: auto; max-width: 500px">
          <h5 class="global-h5" style="margin-bottom: 5px">Important</h5>
          <div>
            <p class="global-p">It's up to YOU to coordinate, transfer compensation, and reply to creator questions. You're in the driver's seat!</p>
            <p class="global-p">Shrpa Creator Visits are an alternative approach where Shrpa sources creators and facilitates the visit.</p>
          </div>
        </div>
      </template>
    </NoteWithIcon>

    <p class="global-p" style="margin-top: 20px">Questions? Reach out to <CopyTextNew>support@shrpa.com</CopyTextNew></p>
  </div>
</template>

<script setup lang="ts">
// Components
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import CopyTextNew from "@components/CopyTextNew.vue";
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.how-it-works-section {
  &__list {
    @include standardFont;
    margin-bottom: 25px;
  }

  &__info-snippet {
  }
}
</style>
